import _ from 'lodash';
import React from 'react';
import { Card, CardHeader, CardFooter, CardBody } from 'reactstrap';
import { PropTypes } from '~/utils';
import { useSpatialNav, useCallback } from '~/hooks';
import { useGlobalContext } from '~/context';

export function Overlay( { title, children } ) {
  const { dispatch } = useGlobalContext();

  useSpatialNav( useCallback( ( key, ev, spatial ) => {
    if ( key === 'Escape' ) {
      dispatch.overlay.close();
      return true;
    }
    return false;
  }, [ dispatch ] ) );
  return (
    <Card className="overlay">
      { title && <CardHeader>{title}</CardHeader> }
      <CardBody>{children}</CardBody>
      <CardFooter>
        <kbd>Escape</kbd>&nbsp;&nbsp;<span>Return to Previous Screen</span>
      </CardFooter>
    </Card>
  );
}
Overlay.propTypes = {
  title     : PropTypes.string,
  children  : PropTypes.node.isRequired,
};
